import { createFileRoute } from "@tanstack/react-router";
import { IndirectCostsPage } from "../../../pages/indirect-costs-page/indirect-costs-page";

export const Route = createFileRoute("/_auth/_project/indirect-costs/$projectId/$subProjectId")({
  component: IndirectCostsPage,
});
